import { render, staticRenderFns } from "./Step3Vrtl.vue?vue&type=template&id=14660fa8"
import script from "./Step3Vrtl.vue?vue&type=script&lang=js"
export * from "./Step3Vrtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports